import React from 'react'
import cx from 'classnames'
interface Props {
  id?: string
  size?: 'small' | 'medium'
  label?: string | React.ReactNode
  checked: boolean
  errorMessage?: string
  // TODO: Antonio revisar
  // eslint-disable-next-line no-unused-vars
  onChange: (value: boolean) => void
}

const Switch = ({
  id = 'switch',
  label,
  checked = false,
  onChange,
  size = 'medium',
  errorMessage,
}: Props) => {
  return (
    <div className={cx('switch', size, { 'has-error': errorMessage })}>
      <button
        className={cx('switch-button', { 'is-checked': checked })}
        type="button"
        id={id}
        aria-checked={checked}
        onClick={() => onChange(!checked)}
      >
        <span className="sr-only">{checked ? 'Encendido' : 'Apagado'}</span>
        <span className="switch-button-handle" />
      </button>
      {label && (
        <label className="switch-label" htmlFor={id}>
          {label}
        </label>
      )}
      {errorMessage && <p className="switch-errorMessage">{errorMessage}</p>}
    </div>
  )
}

export default Switch
